import { Text, View } from "react-native";
import { format, formatDistanceToNow, differenceInMinutes } from "date-fns";
import { formatDate } from "ui/utils/dateUtils";

interface Props {
  time: string;
}

export default function MedicationTimeContent({ time }: Props) {
  const createdAt = new Date(time);
  const minutesDifference = differenceInMinutes(new Date(), createdAt);

  let displayTime = "";
  if (minutesDifference < 60) {
    displayTime = `${formatDate(time)} ${formatDistanceToNow(createdAt, { addSuffix: true })}`;
  } else {
    displayTime = `${formatDate(time)} at ${format(createdAt, "h:mm a")}`;
  }

  return (
    <View className="flex flex-row items-center">
      <Text className="font-medium">{displayTime}</Text>
    </View>
  );
}
